import React from 'react';
import PropTypes from 'prop-types';

import FindRepForm from './FindRepForm';

import {
    AnimationContainer,
    Container as BaseContainer,
    Body as BaseBody
} from '../Shared/PopupModalStyles';

const Container = BaseContainer.extend`
    width: 100;

    @media (max-width: 30em) {
        width: 100%;
    }
`;

const Body = BaseBody.extend`
    padding: 25px 20px;
`;

const RepEmailRedirectPopup = props => (
    <AnimationContainer>
        <Container>
            <Body>
                <FindRepForm
                    isDoubleCheckRepPopup={true}
                    submitting={props.isSubmitting}
                    formattedReps={props.formattedReps}
                    onBack={props.toggleDoubleCheckRepPopup}
                    isLocalRepLoading={props.isLocalRepLoading}
                    imgSources={props.imgSources}
                    handleSubmit={event => {
                        event.preventDefault();
                        props.onSubmit();
                    }}
                />
            </Body>
        </Container>
    </AnimationContainer>
);

RepEmailRedirectPopup.propTypes = {
    formattedReps: PropTypes.string,
    toggleDoubleCheckRepPopup: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
    imgSources: PropTypes.array.isRequired,
    isLocalRepLoading: PropTypes.bool.isRequired,
    isSubmitting: PropTypes.bool
};

export default RepEmailRedirectPopup;
